/* unplugin-vue-components disabled */import { render } from "./signal.vue?vue&type=template&id=263844a5&scoped=true"
import script from "./signal.vue?vue&type=script&lang=js"
export * from "./signal.vue?vue&type=script&lang=js"

import "./signal.vue?vue&type=style&index=0&id=263844a5&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263844a5"],['__file',"src/pages/pulse/signal/signal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "263844a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('263844a5', __exports__)) {
    api.reload('263844a5', __exports__)
  }
  
  module.hot.accept("./signal.vue?vue&type=template&id=263844a5&scoped=true", () => {
    api.rerender('263844a5', render)
  })

}


export default __exports__